import type { FC } from 'react';
import { PodcastOutline } from '@eqi-investimentos/icons/web';
import { Button, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';

export const AudioModeButton: FC<AudioModeButtonProps> = ({ onClick }) => {
  const t = useT();

  return (
    <Button
      aria-label={t('attributes.audioMode')}
      rightIcon={<PodcastOutline />}
      gap="2xs"
      alignItems="center"
      h="1.25rem"
      size="lg"
      fontWeight="semibold"
      variant="naked"
      color="content.brand"
      onClick={onClick}
    >
      <Text size="label.xl" fontWeight="semibold">
        {t('attributes.audioMode')}
      </Text>
    </Button>
  );
};

export type AudioModeButtonProps = {
  onClick: () => void;
};
